// Deterministic seeded RNG (mulberry32). The seed is part of the document so
// identical documents always reproduce identical patterns.

export type Rng = () => number

export function makeRng(seed: number): Rng {
  let a = seed >>> 0
  if (a === 0) a = 0x9e3779b9
  return function () {
    a |= 0
    a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
